/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BrandCredentialDetailedDto } from './BrandCredentialDetailedDto';
import {
    BrandCredentialDetailedDtoFromJSON,
    BrandCredentialDetailedDtoFromJSONTyped,
    BrandCredentialDetailedDtoToJSON,
} from './BrandCredentialDetailedDto';
import type { CampaignCredentialDetailedDto } from './CampaignCredentialDetailedDto';
import {
    CampaignCredentialDetailedDtoFromJSON,
    CampaignCredentialDetailedDtoFromJSONTyped,
    CampaignCredentialDetailedDtoToJSON,
} from './CampaignCredentialDetailedDto';
import type { CredentialDetailedDto } from './CredentialDetailedDto';
import {
    CredentialDetailedDtoFromJSON,
    CredentialDetailedDtoFromJSONTyped,
    CredentialDetailedDtoToJSON,
} from './CredentialDetailedDto';
import type { TNAllocationCredentialDetailedDto } from './TNAllocationCredentialDetailedDto';
import {
    TNAllocationCredentialDetailedDtoFromJSON,
    TNAllocationCredentialDetailedDtoFromJSONTyped,
    TNAllocationCredentialDetailedDtoToJSON,
} from './TNAllocationCredentialDetailedDto';

/**
 * 
 * @export
 * @interface DossierDetailsResponseDto
 */
export interface DossierDetailsResponseDto {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof DossierDetailsResponseDto
     */
    dossierSaid?: string;
    /**
     * 
     * @type {CredentialDetailedDto}
     * @memberof DossierDetailsResponseDto
     */
    orgIdentityCred?: CredentialDetailedDto;
    /**
     * 
     * @type {CredentialDetailedDto}
     * @memberof DossierDetailsResponseDto
     */
    rangeCred?: CredentialDetailedDto;
    /**
     * 
     * @type {TNAllocationCredentialDetailedDto}
     * @memberof DossierDetailsResponseDto
     */
    tnAllocCred?: TNAllocationCredentialDetailedDto;
    /**
     * 
     * @type {CredentialDetailedDto}
     * @memberof DossierDetailsResponseDto
     */
    delegatedSignerCred?: CredentialDetailedDto;
    /**
     * 
     * @type {BrandCredentialDetailedDto}
     * @memberof DossierDetailsResponseDto
     */
    brandCred?: BrandCredentialDetailedDto;
    /**
     * 
     * @type {CampaignCredentialDetailedDto}
     * @memberof DossierDetailsResponseDto
     */
    campaignCred?: CampaignCredentialDetailedDto;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof DossierDetailsResponseDto
     */
    credentialsProof?: { [key: string]: string; };
}


/**
 * @export
 */
export const DossierDetailsResponseDtoCredentialsProofEnum = {
    Valid: 'VALID',
    Expired: 'EXPIRED',
    Missing: 'MISSING',
    Revoked: 'REVOKED'
} as const;
export type DossierDetailsResponseDtoCredentialsProofEnum = typeof DossierDetailsResponseDtoCredentialsProofEnum[keyof typeof DossierDetailsResponseDtoCredentialsProofEnum];


/**
 * Check if a given object implements the DossierDetailsResponseDto interface.
 */
export function instanceOfDossierDetailsResponseDto(value: object): boolean {
    return true;
}

export function DossierDetailsResponseDtoFromJSON(json: any): DossierDetailsResponseDto {
    return DossierDetailsResponseDtoFromJSONTyped(json, false);
}

export function DossierDetailsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DossierDetailsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'dossierSaid': json['dossierSaid'] == null ? undefined : json['dossierSaid'],
        'orgIdentityCred': json['orgIdentityCred'] == null ? undefined : CredentialDetailedDtoFromJSON(json['orgIdentityCred']),
        'rangeCred': json['rangeCred'] == null ? undefined : CredentialDetailedDtoFromJSON(json['rangeCred']),
        'tnAllocCred': json['tnAllocCred'] == null ? undefined : TNAllocationCredentialDetailedDtoFromJSON(json['tnAllocCred']),
        'delegatedSignerCred': json['delegatedSignerCred'] == null ? undefined : CredentialDetailedDtoFromJSON(json['delegatedSignerCred']),
        'brandCred': json['brandCred'] == null ? undefined : BrandCredentialDetailedDtoFromJSON(json['brandCred']),
        'campaignCred': json['campaignCred'] == null ? undefined : CampaignCredentialDetailedDtoFromJSON(json['campaignCred']),
        'credentialsProof': json['credentialsProof'] == null ? undefined : json['credentialsProof'],
    };
}

export function DossierDetailsResponseDtoToJSON(value?: DossierDetailsResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dossierSaid': value['dossierSaid'],
        'orgIdentityCred': CredentialDetailedDtoToJSON(value['orgIdentityCred']),
        'rangeCred': CredentialDetailedDtoToJSON(value['rangeCred']),
        'tnAllocCred': TNAllocationCredentialDetailedDtoToJSON(value['tnAllocCred']),
        'delegatedSignerCred': CredentialDetailedDtoToJSON(value['delegatedSignerCred']),
        'brandCred': BrandCredentialDetailedDtoToJSON(value['brandCred']),
        'campaignCred': CampaignCredentialDetailedDtoToJSON(value['campaignCred']),
        'credentialsProof': value['credentialsProof'],
    };
}

